import { REHYDRATE } from 'redux-persist'
import {
  VEHICLE_EXCLUSIONS_FETCH,
  VEHICLE_EXCLUSIONS_LOOKUP
} from '../actions'

const INIT_STATE = {
  rows: [],
  exclusion_types: [],
  lookups: {
    make: [],
    model: [],
    vehicle_type: []
  }
}

const normalizePayload = (payload) => {
  if (payload && payload.entity && typeof payload.entity === 'object') {
    return payload.entity
  }
  if (payload && payload.result && typeof payload.result === 'object') {
    return payload.result
  }
  return payload || {}
}

const handler = (state = INIT_STATE, action) => {
  switch (action.type) {
    case VEHICLE_EXCLUSIONS_FETCH.REQUEST: {
      return { ...state, rows: [] }
    }
    case VEHICLE_EXCLUSIONS_FETCH.SUCCESS: {
      const data = normalizePayload(action.payload)
      return {
        ...state,
        rows: data.rows || [],
        exclusion_types: data.exclusion_types || []
      }
    }
    case VEHICLE_EXCLUSIONS_LOOKUP.SUCCESS: {
      const data = normalizePayload(action.payload)
      const field = data.field
      if (!field) {
        return state
      }
      return {
        ...state,
        lookups: {
          ...state.lookups,
          [field]: data.options || []
        }
      }
    }
    case REHYDRATE: {
      return INIT_STATE
    }
    default:
      return { ...state }
  }
}

export default handler
